import { render, staticRenderFns } from "./person_change_apply.vue?vue&type=template&id=61520654&scoped=true&"
import script from "./person_change_apply.vue?vue&type=script&lang=js&"
export * from "./person_change_apply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61520654",
  null
  
)

export default component.exports